import styled from 'styled-components'
import { device } from 'src/theme/theme'

export const Nav = styled.nav`
  height: calc(100vh - 140px);
  border-right: 1px solid ${p => p.theme.colors.palette.neutral400};

  @media ${device.tablet} {
    border-right: 0;
  }

  ul {
    margin: 0;
    list-style: none;
    display: list-item;

    @media ${device.tablet} {
      max-height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      padding-bottom: 180px;
    }
  }

  li + li {
    @media ${device.tablet} {
      margin-top: 0;
      margin-left: 0;
    }
  }

  li {
    display: block;
    overflow: hidden;
    border-bottom: 1px solid ${({ theme }) => theme.colors.palette.neutral450};
    transition: all 0.3s ease 0s;

    .nav {
      max-height: 0px;
      padding: 0px;
      transition: all 0.2s ease 0s;
      overflow: hidden;

      &.opened {
        height: auto;
      }
      &.closed {
        padding: 0;
      }
    }

    @media ${device.tablet} {
      height: 100%;
      div {
        height: 0%;
      }
    }

    &.active {
      button {
        color: ${({ theme }) => theme.colors.secondaryBackgroundColor};
        border-color: ${({ theme }) => theme.colors.secondaryBackgroundColor};
      }
    }
  }
`

export const Module = styled.div`
  width: 100%;
  height: 100%;
  padding: ${p => p.theme.spacing.small};
  ${({ theme }) => ({ ...theme.size.xxs })};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: ${({ theme }) => theme.colors.primaryBackgroundColor};
  cursor: pointer;
  min-width: 250px;

  @media ${device.tablet} {
    min-width: ${'300px'};
  }

  & + & {
    margin-top: 0;
  }

  span {
    margin: 5px 0 0 5px;
    display: flex;
    align-items: center;
    ${p => ({ ...p.theme.typography.primary.bold })};

    i {
      display: inline-block;
      width: 15px;
      height: 15px;
      background: #fff;
      border-radius: 10px;
      margin-right: ${p => p.theme.spacing.extraSmall};

      svg {
        display: none;
      }

      &.pending {
        border: 3px solid ${p => p.theme.colors.palette.neutral400};
      }

      &.in-progress {
        border-color: ${p => p.theme.colors.palette.green400} #e2e7ed #e2e7ed
          ${p => p.theme.colors.palette.green400};
        border-style: solid;
        border-width: 2px;
      }

      &.completed {
        border: none;
        svg {
          display: block;
          width: 15px;
          height: 15px;
        }
      }
    }
  }

  .topic {
    margin-left: 30px;
    color: ${({ theme }) => theme.colors.primaryBackgroundColor};
  }

  :hover {
    color: ${({ theme }) => theme.colors.secondaryBackgroundColor};
    border-color: ${({ theme }) => theme.colors.secondaryBackgroundColor};
  }
`

export const Title = styled.div`
  width: 100%;
  justify-content: flex-start;
  border-radius: 0 !important;
  display: flex;
  align-items: flex-start;

  .progress-bar-container {
    width: 30px;
    min-width: 30px;
    text-align: center;
    transition: all 0.3s ease 0s;
    display: inline-block;
    .circle {
      font-size: 5rem;
    }
  }

  span {
    ${({ theme }) => ({ ...theme.size.xs })};
    ${({ theme }) => ({ ...theme.typography.primary.medium })};
    line-height: 1.3rem;
    margin-left: ${p => p.theme.spacing.extraSmall};
  }

  .span-module {
    i {
      min-width: 1rem;
    }

    .module-text {
      display: block;
      word-wrap: break-word;
      max-width: 250px;
      margin-left: 0;
    }
  }

  .visa {
    color: ${({ theme }) => theme.colors.palette.green400};
  }

  &.classroom {
    cursor: pointer;
    ${({ theme }) => ({ ...theme.size.xxs })};
    span {
      ${({ theme }) => ({ ...theme.size.xxs })};
      color: ${({ theme }) => theme.colors.primaryTextColor};
      line-height: 1rem;

      :hover {
        color: ${({ theme }) => theme.colors.secondaryBackgroundColor};
      }
    }
  }
`

export const SubMenu = styled.div`
  padding: 0.5em 0.5em 0.5em 1.6em;
  transition: all 0.2s ease 0s;
  overflow-y: hidden;
  min-width: 300px;
  background: ${({ theme }) => theme.colors.palette.neutral300};

  &.lesson-visible {
    background: ${({ theme }) => theme.colors.palette.secondary600};

    span {
      color: ${({ theme }) => theme.colors.palette.white};
    }
    .icon {
      color: ${({ theme }) => theme.colors.white};
      &.visa {
        color: ${({ theme }) => theme.colors.palette.green400};
      }
    }
    &:hover {
      span {
        color: ${({ theme }) => theme.colors.white};
      }
    }
  }

  span {
    transition: all 0.2s ease 0s;
  }

  &:hover {
    span {
      color: ${({ theme }) => theme.colors.secondaryBackgroundColor};
    }
  }

  .icon {
    font-size: 0.8rem;
    min-width: 0.8rem;
    color: ${({ theme }) => theme.colors.secondaryTextColor};
    &.visa {
      font-size: 0.8rem;
      min-width: 0.8rem;
      color: ${({ theme }) => theme.colors.palette.green400};
    }
  }
`
